export type GetIFDefinitionsRequest = {
  dfnSetVerNum: string;
  project?: Projects;
  snapshot?: Snapshots;
  includeFileLayout?: string;
};
export type Projects = {
  pjtIds?: string[];
  dsgnTcktStsTypeCds?: string[];
  stgDplymntTcktStsTypeCds?: string[];
  prdDplymntTcktStsTypeCds?: string[];
  andCondSrcDstTcktSts?: boolean;
  dplymntReqSeqNum?: number;
  srcDipByRgnOrDip?: string;
  srcIfId?: string;
  srcInbdId?: string;
  srcInbdCpntId?: string;
  dstDipByRgnOrDip?: string;
  dstIfId?: string;
  dstOtbdId?: string;
  dstOtbdCpntId?: string;
  interfaceNameJapanese?: string;
  interfaceNameEnglish?: string;
  andCondDip?: boolean;
  andCondIfId?: boolean;
  andCondInOtbdId?: boolean;
  andCondInOtbdCpntId?: boolean;
};
export type Snapshots = {
  srcDipByRgnOrDip?: string;
  srcIfId?: string;
  srcInbdId?: string;
  srcInbdCpntId?: string;
  dstDipByRgnOrDip?: string;
  dstIfId?: string;
  dstOtbdId?: string;
  dstOtbdCpntId?: string;
  interfaceNameJapanese?: string;
  interfaceNameEnglish?: string;
  isPrd?: boolean;
  andCondDip?: boolean;
  andCondIfId?: boolean;
  andCondInOtbdId?: boolean;
  andCondInOtbdCpntId?: boolean;
};
